import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/CWP_logo.svg'


const _withScopeId = n => (_pushScopeId("data-v-030f135e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "navbar bg-light fixed-top" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  class: "navbar-brand",
  href: "/"
}, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "CWP",
    height: "45"
  })
], -1))
const _hoisted_4 = { class: "d-flex" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"65px","width":"100vw"} }, null, -1))
const _hoisted_6 = { class: "container p-4" }
const _hoisted_7 = { class: "row mb-2" }
const _hoisted_8 = { class: "col-lg-4 mb-2" }
const _hoisted_9 = { class: "card" }
const _hoisted_10 = { class: "eco-card p-2 d-flex flex-column" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Баланс", -1))
const _hoisted_12 = { class: "mt-auto d-flex align-items-center" }
const _hoisted_13 = { class: "ms-auto" }
const _hoisted_14 = { class: "col-lg-4 mb-2" }
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" Запуск мойки ")
const _hoisted_16 = { class: "d-flex" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "submit",
  class: "btn btn-sm btn-success"
}, " Запустить ", -1))
const _hoisted_18 = /*#__PURE__*/_createTextVNode(" Номер указан на терминале! ")
const _hoisted_19 = {
  key: 0,
  class: "w-100 h-100 d-flex"
}
const _hoisted_20 = { class: "my-auto w-100" }
const _hoisted_21 = { class: "mb-2" }
const _hoisted_22 = { key: 1 }
const _hoisted_23 = /*#__PURE__*/_createTextVNode(" К сожалению, запущенную мойку не возможно остановить, обратитесь к оператору! ")
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "pt-5 text-secondary" }, " v1.0.2 ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_g_text = _resolveComponent("g-text")!
  const _component_g_card = _resolveComponent("g-card")!
  const _component_home_operations = _resolveComponent("home-operations")!
  const _component_pay_popup = _resolveComponent("pay-popup")!
  const _component_home_q_r_code = _resolveComponent("home-q-r-code")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("nav", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("a", {
            class: "btn btn-sm btn-danger",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.logout && _ctx.logout(...args)))
          }, "Выход")
        ])
      ])
    ]),
    _hoisted_5,
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", null, [
                _hoisted_11,
                _createElementVNode("div", null, _toDisplayString(_ctx.auth.balance / 100) + " ₽ ", 1)
              ]),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", null, _toDisplayString(_ctx.auth.phone), 1),
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("a", {
                    class: "btn btn-sm btn-secondary",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.openPay()))
                  }, "Пополнить")
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_14, [
          (!_ctx.auth.wash_start)
            ? (_openBlock(), _createBlock(_component_g_card, { key: 0 }, {
                header: _withCtx(() => [
                  _hoisted_15
                ]),
                footer: _withCtx(() => [
                  _hoisted_18
                ]),
                default: _withCtx(() => [
                  _createElementVNode("form", {
                    onSubmit: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.washStart && _ctx.washStart(...args)), ["prevent"]))
                  }, [
                    _createVNode(_component_g_text, {
                      label: "Номер терминала",
                      placeholder: "4 цифры",
                      required: "",
                      modelValue: _ctx.terminal_code,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.terminal_code) = $event))
                    }, null, 8, ["modelValue"]),
                    _createElementVNode("div", _hoisted_16, [
                      _hoisted_17,
                      _createElementVNode("a", {
                        class: "ms-auto btn btn-sm btn-danger",
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showQRcode = true))
                      }, " Отсканировать QR ")
                    ])
                  ], 32)
                ]),
                _: 1
              }))
            : (_openBlock(), _createBlock(_component_g_card, {
                key: 1,
                class: "h-100"
              }, {
                default: _withCtx(() => [
                  (_ctx.can_stop)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                        _createElementVNode("div", _hoisted_20, [
                          _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.city) + ", " + _toDisplayString(_ctx.address), 1),
                          _createElementVNode("a", {
                            class: "w-100 btn btn-sm btn-success",
                            onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.washStop && _ctx.washStop(...args)))
                          }, "Остановить мойку")
                        ])
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_22, [
                        _createElementVNode("div", null, _toDisplayString(_ctx.city) + " " + _toDisplayString(_ctx.address), 1),
                        _hoisted_23
                      ]))
                ]),
                _: 1
              }))
        ])
      ]),
      _createVNode(_component_home_operations, { "need-reload": _ctx.needOperationsReload }, null, 8, ["need-reload"]),
      (_ctx.showPayPopup)
        ? (_openBlock(), _createBlock(_component_pay_popup, {
            key: 0,
            onClose: _cache[6] || (_cache[6] = ($event: any) => (_ctx.showPayPopup = false))
          }))
        : _createCommentVNode("", true),
      (_ctx.showQRcode)
        ? (_openBlock(), _createBlock(_component_home_q_r_code, {
            key: 1,
            prop_terminal_balance: _ctx.terminal_balance,
            onClose: _ctx.closeQRcode
          }, null, 8, ["prop_terminal_balance", "onClose"]))
        : _createCommentVNode("", true),
      _hoisted_24
    ])
  ], 64))
}